import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let FictitiousMap = class FictitiousMap extends VuexModule {
    paintState = false;
    paintData = [];
    hotMapStatus = false;
    isParentId = false;
    UEStatus = false;
    UEHotMapData = [];
    silderValue = 10;
    updataSilderValue(value) {
        this.silderValue = value;
    }
    updataPaintState(status) {
        this.paintState = status;
    }
    updataUEStatus(status) {
        this.UEStatus = status;
    }
    updataUEHotMapData(data) {
        this.UEHotMapData = data;
    }
    clearUEHotMapData() {
        this.UEHotMapData = [];
    }
    updataPaintData(data) {
        this.paintData = data;
    }
    clearPaintData() {
        this.paintData = [];
    }
    updataHotMapStatus(data) {
        this.hotMapStatus = data;
    }
    updataIsParentId(data) {
        this.isParentId = data;
    }
};
__decorate([
    Mutation
], FictitiousMap.prototype, "updataSilderValue", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "updataPaintState", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "updataUEStatus", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "updataUEHotMapData", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "clearUEHotMapData", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "updataPaintData", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "clearPaintData", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "updataHotMapStatus", null);
__decorate([
    Mutation
], FictitiousMap.prototype, "updataIsParentId", null);
FictitiousMap = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/FictitiousMap' })
], FictitiousMap);
export const FictitiousMapModule = getModule(FictitiousMap);
